export default __webpack_public_path__ + "static/media/oncology.7adff2be.png";